import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import UserLogin from './pages/UserLogin'
import MentorLogin from './pages/MentorLogin'
import UserAuthContextProvider from './hooks/UserAuthContext'
import MentorAuthContextProvider from './hooks/MentorAuthContext'
import UserApp from './UserApp'
import MentorApp from './MentorApp'
import ProtectedRoute from './pages/ProtectedRoute'
import Login from './pages/Login'
import BookingRedirect from './components/BookingRedirect'
import { MeetingAppProvider } from './MeetingAppContextDef'

function Main() {
    return (
        <BrowserRouter>
            <MeetingAppProvider>
                <UserAuthContextProvider>
                    <MentorAuthContextProvider>
                        <Routes>
                            <Route index element={<Navigate to='/login' />} />
                            <Route path="booking/:booking_id" element={<BookingRedirect />} />
                            <Route path="login" element={<Login />} />
                            <Route path='user/login' element={<UserLogin />} />
                            <Route path='mentor/login' element={<MentorLogin />} />
                            <Route path="user/meet" element={
                                <ProtectedRoute>
                                    <UserApp />
                                </ProtectedRoute>
                            } />
                            <Route path="mentor/meet" element={
                                <ProtectedRoute>
                                    <MentorApp />
                                </ProtectedRoute>
                            } />
                            <Route path='*' element={<Navigate to='/login' />} />
                        </Routes>
                    </MentorAuthContextProvider>
                </UserAuthContextProvider>
            </MeetingAppProvider>
        </BrowserRouter>
    )
}

export default Main